import type { App } from 'vue';
import { Icon } from '@/components/basic-components/icon';

/**
 * 注册全局组件
 * @param app Vue 应用实例
 */
export function registerGlobalComponents(app: App) {
  // 注册基础组件
  app.component('Icon', Icon);

  // 在此处添加更多需要全局注册的组件
  // app.component('ComponentName', Component);
}
